/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_28d45916{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_28d45916{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_28d45916";
export const item = "item_28d45916";